<template>
  <v-container
    fluid
    grid-list-md
    class="main-list__container crud__container"
    :class="classEmptyContainer"
  >

    <v-btn
      fab
      @click="$router.push(`${entity.collection}/new`)"
      class="main-form__btn-add primary"
    >
      <v-icon v-text="'add'" />
    </v-btn>

    <div>
      <v-flex
        class="main-list__empty-container"
        v-if="loading"
      >
        <v-progress-circular
          :width="3"
          color="red"
          indeterminate
          v-if="loading || !listItems.length"
        />
      </v-flex>

      <v-card v-else-if="listItems.length">
        <v-card-title>
          <h2
            class="headline"
            primary-title
            v-text="entity.name.plural"
          />
          <v-spacer />
          <v-text-field
            v-model="query"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
          />
        </v-card-title>

        <v-data-table
          :headers="$route.meta.entity.tableHeaders"
          :items="listItems"
          :search="query"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td
              style="cursor: pointer"
              v-for="field in bodyColumns"
              :key="field"
              v-text="props.item[field]"
              @click="openItem(props.item)"
            />
            <td class="justify-center actions-column">
              <v-icon
                small
                class="mr-2"
                @click="openItem(props.item)"
                v-text="'edit'"
              />
              <v-icon
                small
                @click="itemDelete(props.item)"
                v-text="'delete'"
              />
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CrudList',
  data () {
    return {
      loading: true,
      singleSelect: false,
      list: [],
      fields: [],
      query: ''
    }
  },
  watch: {
    $route (val) {
      this.setOriginalState()
    }
  },
  computed: {
    ...mapGetters({
      listItems: 'crud/listItems',
      currentUser: 'authentication/currentUser'
    }),
    classEmptyContainer () {
      return this.listItems[0] || this.loading ? '' : 'main-list__container--empty'
    },
    bodyColumns () {
      const temp = Array.from(this.fields)
      temp.pop()
      return temp
    },
    entity () {
      return this.$route.meta.entity
    }
  },
  methods: {
    ...mapActions('crud', ['getList', 'getItem', 'createItem', 'updateItem', 'deleteItem', 'selectItem']),
    submit: function () {
      this.create(this.task)
    },
    setOriginalState: async function () {
      this.loading = true
      await this.getList({ currentUserId: this.currentUser.uid, collection: this.entity.collection })
      if (this.listItems.length) {
        const tempItems = this.listItems.map((item) => {
          const tempObj = {}
          tempObj.id = item.id
          this.fields = this.entity.tableHeaders.map(column => column.value)
          for (let i = 0; i < this.fields.length; i++) {
            tempObj[this.fields[i]] = item[this.fields[i]]
          }
          return tempObj
        })
        this.list = Array.from(tempItems)
      }
      this.loading = false
    },
    openItem: function (item) {
      this.selectItem(item)
      this.$router.push(`${this.entity.collection}/${item.id}`)
      // this.$emit('edit')
    },
    itemDelete: function (item) {
      if (confirm('Você deseja mesmo deletar este item?')) {
        this.deleteItem({ currentUserId: this.currentUser.uid, collection: this.entity.collection, item })
      }
    }
  },
  async created () {
    this.setOriginalState()
  }
}
</script>
<style lang="stylus">
  .main-list__container
    padding 20px
</style>
